<template>
  <v-container>
    <v-card>
      <v-card-title>Materias del Tronco Común</v-card-title>
      <v-card-subtitle>Consulta</v-card-subtitle>
      <v-card-text style="height: 15px; position: relative; top: -30px">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              absolute
              top
              right
              fab
              v-bind="attrs"
              v-on="on"
              @click="nuevaMateria"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Agregar Materia</span>
        </v-tooltip>
      </v-card-text>
    </v-card>

    <v-divider />

    <v-card class="px-4">
      <v-row>
        <v-col cols="12" sm="6" md="4" v-for="n in 6" :key="n">
          <v-card>
            <v-card-title class="primary py-2">Semestre {{ n }}</v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item
                  link
                  v-for="materia in semestreNo(n)"
                  :key="materia.id"
                  @click.stop="muestraMateria(materia.id)"
                  >{{ materia.nombre }}</v-list-item
                >
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <Materia
      :open="showMateria"
      :materia="materia"
      :no-eliminar="newMateria"
      @save="actualizaMateria('patch')"
      @exit="ocultaMateria"
      @delete="actualizaMateria('delete')"
    />
  </v-container>
</template>

<script>
import api from "@/api";
import Materia from "@/components/Materia";

export default {
  name: "TroncoComun",

  components: { Materia },

  data: () => ({
    materia: {
      id: "",
      nombre: "",
      academia: "",
      semestre: "",
      orden: "",
      horas: "",
    },
    materias: null,
    newMateria: false,
    showMateria: false,
  }),

  methods: {
    async actualizaMateria(action) {
      let data = {
        table: "tronco_comun",
        scope: "ind",
        data: this.materia,
      };
      if (this.newMateria) {
        data = {
          ...data,
          action: "insert",
        };
      } else {
        if (this.materia.id + "." != ".") {
          data = {
            ...data,
            action: action,
          };
        }
      }
      if (this.newMateria || this.materia.id + "." != ".") {
        try {
          const response = await api.send(data);
          this.getMaterias();
          // this.showMateria = false;
          // this.newMateria = false;
          // this.materia = JSON.parse(
          //   '{"id":"","nombre":"","academia":"","semestre":"","orden":"","horas":""}'
          // );
        } catch (error) {
          console.log(error);
        }
      }
    },

    async getMaterias() {
      const response = await api.send({
        table: "tronco_comun",
        action: "get",
        scope: "all",
      });
      if (response.status == 200) {
        this.materias = response.data;
        this.showMateria = false;
        this.newMateria = false;
        this.materia = JSON.parse(
          '{"id":"","nombre":"","academia":"","semestre":"","orden":"","horas":""}'
        );
      }
    },

    materiaId(id) {
      if (this.materias) {
        let items = this.materias;
        for (let key in items) {
          if (items[key].id == id) {
            return items[key];
          }
        }
      }
      return null;
    },

    muestraMateria(id) {
      this.showMateria = true;
      this.materia = JSON.parse(JSON.stringify(this.materiaId(id)));
    },

    async nuevaMateria() {
      let response = await api.send({
        table: "tronco_comun",
        action: "max",
        fields: "orden",
      });
      if (response.status == 200) {
        this.materia = JSON.parse(
          '{"id":"","nombre":"","academia":"","semestre":"","orden":"' +
            (parseInt(response.data.maxorden) + 1) +
            '","horas":""}'
        );
      } else {
        this.materia = JSON.parse(
          '{"id":"","nombre":"","academia":"","semestre":"","orden":"","horas":""}'
        );
      }
      this.newMateria = true;
      this.showMateria = true;
    },

    ocultaMateria() {
      this.showMateria = false;
      this.newMateria = false;
      this.materia = JSON.parse(
        '{"id":"","nombre":"","academia":"","semestre":"","orden":"","horas":""}'
      );
    },

    semestreNo(no) {
      if (this.materias) {
        let items = this.materias;
        let list = [];
        let result = Object.keys(items).map(function (key) {
          if (items[key].semestre == no) list.push(items[key]);
          return items[key].semestre == no;
        });
        return list;
      } else return null;
    },
  },

  async mounted() {
    this.$store.commit("setPageTitle", "Tronco Común");
    this.getMaterias();
  },
};
</script>